import { Trans } from 'react-i18next';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { Link, Paragraph } from '@sentara-health/optimahealth_web';
import { t } from 'i18next';

const ChangeHomeAddressDetails = () => {
  const { getFeature, ssoEndPoints } = useContext(GlobalContext);

  const getTranslationString = () => {
    const featureMap: Record<string, string> = {
      HomeAddressCommerical: 'EmployerGroupAddressChange',
      HomeAddressMedicare: 'MedicareAddressChange',
      HomeAddressMedicaid: 'MedicaidAddressChange',
      HomeAddressDSNP: 'DSNPAddressChange',
      HomeAddressIndividOff: 'IndividualOffAddressChange',
      HomeAddressIndividOn: 'IndividualOnAddressChange'
    };

    const activeFeature = Object.keys(featureMap).find(key => getFeature?.[key]);
    if (!activeFeature) return '';

    const translationString = featureMap[activeFeature];
    return `profile.${translationString}`;
  }

  return (
    <div data-testid="alternativeAddressDetails">
      <Paragraph
        text={
          <Trans
            i18nKey={getTranslationString()}
            values={{
              phoneNumber1: t('profile.langPrefTelephone'),
              phoneNumber2: t('maintenance.maintenanceNo'),
              phoneNumber3: t('profile.phoneNumber3')
            }}
            components={{
              Link: (
                <Link
                  to={ssoEndPoints?.individualOnAddressChangeUrl || ''}
                  target="_blank"
                  className="text-decoration-underline"
                />
              ),
              SSALink: (
                <Link
                  to={ssoEndPoints?.medicareAddressChangeUrl || ''}
                  target="_blank"
                  className="text-decoration-underline"
                />
              ),
              CoverVALink: (
                <Link
                  to={ssoEndPoints?.medicaidAddressChangeUrl || ''}
                  target="_blank"
                  className="text-decoration-underline"
                />
              ),
              phoneNumber1: (
                <Link
                  to={`tel:${t('profile.langPrefTelephone')}`}
                  className="text-decoration-underline"
                />
              ),
              phoneNumber2: (
                <Link
                  to={`tel:${t('maintenance.maintenanceNo')}`}
                  className="text-decoration-underline"
                />
              ),
              phoneNumber3: (
                <Link
                  to={`tel:${t('profile.phoneNumber3')}`}
                  className="text-decoration-underline"
                />
              )
            }}
          />
        }
        variant="regular"
        className="pe-1 mb-0"
      />
    </div>
  );
};

export default ChangeHomeAddressDetails;
